import * as constants from './config/constants.js';
import RequestHandler from './utils/request-handler.js';
import LoadingOverlay from './loading-overlay.js';
import ElementClassHandler from './utils/element-class-handler.js';

export default class EsimBasket {
    constructor() {
        this.simTypeElements = document.querySelectorAll('[data-sim-type-choice] input[type="radio"]');
        this.requestHandler = new RequestHandler;
        this.responseMessage = document.querySelector('[data-esim-response-message]');
        this.loadingOverlay = new LoadingOverlay;
        this.deliveryOptionsContainer = document.getElementById('delivery-options-container');
        this.elementsClassHandler = new ElementClassHandler();
        this.deliveryOptionInputs = document.querySelectorAll('[data-delivery-option-input]');
        this.clickAndCollectModal = $('[data-modal-id="click_and_collect_disabled_modal"]');
    }

    setup() {
        this.setupSimTypeSelectionListener();
        this.showModalOnPageLoad();
    }

    setupSimTypeSelectionListener() {
        this.simTypeElements.forEach((el) => {
            this.esimAjaxCall(el);
        });
    }

    showModalOnPageLoad() {
        if (this.clickAndCollectModal.attr('data-show-on-page-load') === 'true') {
            this.clickAndCollectModal.modal();
            this.clickAndCollectModal.removeAttr('data-show-on-page-load');
        }
    }

    esimCallBack(response, additionalArgs) {
        const publicId = additionalArgs.publicId;
        if (response.message) {
            this.responseMessage.innerText = response.message;
        } else {
            this.responseMessage.innerText = 'An unexpected error occurred. Please try again;';
        }
        this.responseMessage.classList.remove(constants.ALERT_ERROR_CLASS, constants.ALERT_SUCCESS_CLASS);
        this.responseMessage.classList.add(constants.ALERT_CLASS);

        if (response.result === 'success') {
            if (response.hasNetworkSwitching) {
                const currentNetworkSwitchingForm = document
                    .querySelector(`.network-switching input[name="publicId"][value="${publicId}"]`)
                    .closest('.network-switching');
                if (currentNetworkSwitchingForm) {
                    const button = currentNetworkSwitchingForm.querySelector('[data-network-switching-button]');
                    const dateSelector = currentNetworkSwitchingForm.querySelector('input[data-datepicker-switching]');
                    const datesDropdown = currentNetworkSwitchingForm.querySelector('[data-network-switching-available-dates]');
                    if (button) {
                        if (dateSelector) {
                            dateSelector.value = "";
                        }
                        if (datesDropdown) {
                            datesDropdown.value = '';
                            datesDropdown.querySelectorAll('option').forEach((option) => {
                                option.selected = false;
                                option.removeAttribute('selected');
                            });
                        }
                        button.click();
                        const collapseToggle = currentNetworkSwitchingForm.querySelector('[data-toggle="collapse"]');
                        collapseToggle && collapseToggle.classList.contains('collapsed') && collapseToggle.click();
                    }
                }
            }
            this.responseMessage.classList.add(constants.ALERT_SUCCESS_CLASS);
        } else {
            this.responseMessage.classList.add(constants.ALERT_ERROR_CLASS);
        }

        if (this.deliveryOptionsContainer) {
            if (response.hideDeliveryOptions) {
                this.elementsClassHandler.hide(this.deliveryOptionsContainer);
            } else {
                this.elementsClassHandler.show(this.deliveryOptionsContainer);
            }
        }

        if (response.clickAndCollectIsNoLongerAnOption) {
            this.clickAndCollectModal.modal();
            this.deliveryOptionInputs.forEach(input => {
                input.checked = input.value === '195';
            });
        }

        this.loadingOverlay.taskFinished();
    }

    esimAjaxCall(el, name) {
        el.addEventListener('change', (e) => {
            const publicId = e.target.closest('[data-esim-basket-section]').dataset.dealLinePublicId;
            const name = 'simTypeChoice';

            let data = `publicId=${publicId}&${name}=${e.target.value}`;
            this.loadingOverlay.taskStarted();

            const additionalArgs = {
                publicId: publicId
            };

            this.requestHandler.post(
                '/basket/sim-type-choice',
                data,
                (response) => this.esimCallBack(response, additionalArgs)
            );
        });
    }
}
